import { useState } from "react";

import "./Landing.css";

import HeaderLog from "../assets/images/header-logo.svg";
import Sec2Img1 from "../assets/images/image1.svg";
import Sec2Img2 from "../assets/images/image3.svg";
import Sec2Img3 from "../assets/images/image5.svg";
import Sec2Img4 from "../assets/images/image7.svg";

import FeaturesImg1 from "../assets/images/features1.svg";
import FeaturesImg2 from "../assets/images/features2.svg";
import FeaturesImg3 from "../assets/images/features3.svg";
import FeaturesImg4 from "../assets/images/features4.svg";
import FeaturesImg5 from "../assets/images/features5.svg";
import FeaturesImg6 from "../assets/images/features6.svg";

import MiddleImg1 from "../assets/images/middle1.svg";
import MiddleImg2 from "../assets/images/middle2.svg";
import MiddleImg3 from "../assets/images/middle3.png";
import MiddleImg2bg from "../assets/images/middle2_bg.svg";

import ConfigsImg from "../assets/images/configs.svg";

import Faciliat1 from "../assets/images/faciliate/1.svg";
import Faciliat2 from "../assets/images/faciliate/2.svg";
import Faciliat3 from "../assets/images/faciliate/3.svg";
import Faciliat4 from "../assets/images/faciliate/4.svg";
import Faciliat5 from "../assets/images/faciliate/5.svg";
import Faciliat6 from "../assets/images/faciliate/6.svg";
import Faciliat7 from "../assets/images/faciliate/7.svg";
import Faciliat8 from "../assets/images/faciliate/8.svg";
import Faciliat9 from "../assets/images/faciliate/9.svg";

import Models1 from "../assets/images/models/models1.svg";
import Models2 from "../assets/images/models/models2.svg";
import Models3 from "../assets/images/models/models3.svg";

import Benefits1 from "../assets/images/benefits/1.svg";
import Benefits2 from "../assets/images/benefits/2.svg";
import Benefits3 from "../assets/images/benefits/3.svg";
import Benefits4 from "../assets/images/benefits/4.svg";
import Benefits5 from "../assets/images/benefits/5.svg";
import Benefits6 from "../assets/images/benefits/6.svg";

import AboutImg from "../assets/images/about-img.svg";

import { FiPhoneCall } from "react-icons/fi";
import { FaEnvelope } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";


const Landing = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const scrollTo = (id) => {
        const element = document.getElementById(id);
        element.scrollIntoView({ behavior: "smooth" });
        setMenuOpen(false);
    }

    return (
        <div className="">
            <header className="custom-header container">
                <nav className="navbar d-flex justify-content-between">
                    <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
                        <img src={HeaderLog} alt="Menu Logo" className="menu-logo" />
                        <div className="d-flex justify-content-end gap-2 ms-4">
                            <button className="btn nav-btn" onClick={() => scrollTo('home')}>
                                خانه
                            </button>
                            <button className="btn nav-btn" onClick={() => scrollTo('features')}>
                                ویژگی های خِردجو
                            </button>
                            <button className="btn nav-btn" onClick={() => scrollTo('about-us')}>
                                درباره ما
                            </button>
                            <button className="btn nav-btn" onClick={() => scrollTo('footer')}>
                                تماس با ما
                            </button>
                        </div>
                    </div>
                    <div className="">
                        <button className="hamburger" onClick={toggleMenu}>
                            <span className="hamburger-icon"></span>
                        </button>
                    </div>
                    <div className="">
                        <button className="btn-custom-primary main-btn">درخواست جلسه</button>
                    </div>
                </nav>
            </header>

            <section className="hero-section" id="home">
                <div className="container">
                    <div className="row align-items-center hero-container g-4 g-lg-5">
                        <div className="col-lg-6 col-12">
                            <div className="hero-video-wrapper">
                                <div className="hero-video-container">
                                    <iframe
                                        src="https://www.aparat.com/video/video/embed/videohash/zpa8xgw/vt/frame?playlist=26872366"
                                        title="معرفی مدیریت دانش گفتگومحور هوشمند، خردجو"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        webkitallowfullscreen="true"
                                        mozallowfullscreen="true"
                                    ></iframe>
                                </div>
                                <div className="hero-video-badge" aria-hidden="true">
                                    <svg viewBox="275 235 225 195" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M282.999 396.747L474.308 242.071C484.117 234.141 498.739 241.122 498.739 253.736V408.411C498.739 416.695 492.023 423.411 483.739 423.411H292.43C278.29 423.411 272.003 405.637 282.999 396.747Z"
                                            fill="#6E44FF"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 text-container">
                            <h4 className="hero-title">
                                مدیریت دانش گفتگومحور هوشمند؛ <span>خِردجو</span>
                            </h4>
                            <p className="custom-p" style={{ lineHeight: '38px' }}>
                                خِردجو اولین ابزار سازمانی مدیریت گفتگومحور دانش بر پایه هوش مصنوعی و مبتنی بر LLM است.
                                خِردجو سریع‌ترین و آسان‌ترین دسترسی را به داده‌ها، اطلاعات، آموزش‌ها، دستورالعمل‌ها و ...
                                برای کاربران مورد نظر شما فراهم می‌کند و دانش موجود را برای سازمان شما قابل مدیریت و
                                بهره‌برداری می‌کند. </p>
                            <button className="btn-custom-primary main-btn">راه‌های ارتباطی</button>
                        </div>
                    </div>
                </div>
            </section>

            <div className="">
                <hr className="custom-hr" />
            </div>

            <section className="sponsors d-flex justify-content-center container">
                <img src={Sec2Img4} alt="Sponsor 4" className="sponsor-img" />
                <img src={Sec2Img2} alt="Sponsor 2" className="sponsor-img" />
                <img src={Sec2Img3} alt="Sponsor 3" className="sponsor-img" />
                <img src={Sec2Img1} alt="Sponsor 1" className="sponsor-img" />
            </section>

            <section className="features container" id="features">
                <div className="card border-0" style={{ background: '#F5F2FF' }}>
                    <h4 className="text-center mt-5 mb-3 fw-bold fs-2">کاربردهای <span
                        style={{ color: 'var(--primary-color)' }}>خِردجو</span> در بخش‌های مختلف سازمان</h4>
                    <p className="custom-p text-center w-50 mx-auto fw-light lh-lg">خردجو تعداد زیادی سازمان را با
                        مهندسین و مشاوران
                        کسب‌ و کار با
                        تجربه مورد بررسی قرار داده است تا برای تمام نیازهای دانشی سازمان راهکاری یکپارچه ارائه دهد.</p>
                    <div className="d-flex flex-wrap">
                        <div className="card-body container gap-4 justify-content-center w-auto h-100">
                            <div className="card feature-card">
                                <img src={FeaturesImg1} alt="Feature 1" className="feature-img" />
                                <h5 className="fw-bold mb-3">سیستم منابع انسانی</h5>
                                <p className="custom-p" style={{ lineHeight: '34px' }}>آگاهی کاربران مربوطه از رویه‌های
                                    اعطای وام، حقوق و ...</p>
                            </div>
                        </div>
                        <div className="card-body container gap-4 justify-content-center w-auto">
                            <div className="card feature-card">
                                <img src={FeaturesImg2} alt="Feature 1" className="feature-img" />
                                <h5 className="fw-bold mb-3">سیستم تامین و نگهداری</h5>
                                <p className="custom-p" style={{ lineHeight: '34px' }}>امکان پرسش سوالات در مورد قطعات،
                                    عیب‌یابی و بخش‌های مختلف خط
                                    تولید برای تکنیسین‌ها و مدیران</p>
                            </div>
                        </div>
                        <div className="card-body container gap-4 justify-content-center w-auto">
                            <div className="card feature-card">
                                <img src={FeaturesImg3} alt="Feature 1" className="feature-img" />
                                <h5 className="fw-bold mb-3">سیستم آموزش کارکنان</h5>
                                <p className="custom-p" style={{ lineHeight: '34px' }}>امکان پرسش‌ و پاسخ‌های آموزشی برای
                                    کارکنان سازمان در کلیه
                                    سطوح</p>
                            </div>
                        </div>
                        <div className="card-body container gap-4 justify-content-center w-auto">
                            <div className="card feature-card">
                                <img src={FeaturesImg4} alt="Feature 1" className="feature-img" />
                                <h5 className="fw-bold mb-3">واحد ایمنی و بهداشت(HSE)</h5>
                                <p className="custom-p" style={{ lineHeight: '34px' }}>امکان رفع چالش وجود قوانین و مقررات
                                    بی‌شمار در زمینه HSE یک
                                    سازمان</p>
                            </div>
                        </div>
                        <div className="card-body container gap-4 justify-content-center w-auto">
                            <div className="card feature-card">
                                <img src={FeaturesImg5} alt="Feature 1" className="feature-img" />
                                <h5 className="fw-bold mb-3">مدیریت دانش فنی</h5>
                                <p className="custom-p" style={{ lineHeight: '34px' }}>امکان دسته‌بندی و ایجاد شرایط
                                    دسترسی به اطلاعات فنی و مهم
                                    سامانه‌های نرم‌افزاری پیچیده</p>
                            </div>
                        </div>
                        <div className="card-body container gap-4 justify-content-center w-auto">
                            <div className="card feature-card">
                                <img src={FeaturesImg6} alt="Feature 1" className="feature-img" />
                                <h5 className="fw-bold mb-3">بخش‌های شخصی‌سازی شده</h5>
                                <p className="custom-p" style={{ lineHeight: '34px' }}>امکان ایجاد هر گونه دسترسی با هر
                                    شکل و هر سطح از پیچیدگی‌ برای
                                    سازمان‌ها</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="row d-flex mt-5 container mx-auto">
                <div className="col-lg-6 col-md-12 col-sm-12 my-auto mx-auto">
                    <h5 className="mt-5 mb-lg-4 mb-3 fw-bold fs-4">خِردجو دقیقا چه مشکلی را حل می‌کند؟</h5>
                    <p className="custom-p fw-light" style={{ lineHeight: '42px', fontSize: '20px' }}>
                        سازمان‌های بزرگ، دارای اسناد و داده‌های بسیار زیادی هستند که معمولا نمی‌توانند از آنها با
                        بهره‌وری بالا استفاده نمایند. بخشی از این اسناد و اطلاعات به صورت دانش درآمده‌اند و بخشی به صورت
                        داده و اطلاعات خام و دسته‌بندی نشده در سیستم قرار دارند. اینکه سازمان بتواند از این اطلاعات به
                        درستی و با سرعت استفاده نماید تبدیل به یک چالش جدی شده است. دسترسی به موقع به اطلاعات مناسب،
                        تجمیع و نتیجه‌گیری از آن‌ها امری است که فقط به صورت هوشمند میسر بوده و تاکنون نیز هوش مصنوعی
                        نتوانسته راه حل کامل آن را ارائه نماید.
                    </p>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 text-center">
                    <img
                        src={MiddleImg1}
                        alt="Middle Image"
                        className="mx-auto"
                        style={{ maxWidth: "450px", width: "100%", height: "auto" }}
                    />
                </div>
            </div>

            <section style={{ marginBlock: '150px' }}>
                <div className="row d-flex mx-auto container">
                    <div className="col-lg-6 col-md-12 col-sm-12 text-center my-auto">
                        <img
                            src={MiddleImg2}
                            alt="Middle Image"
                            className="mx-auto my-auto"
                            style={{ maxWidth: "450px", width: "100%", height: "auto" }}
                        />
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 my-auto mx-auto">
                        <h5 className="mt-5 mb-lg-4 mb-3 fw-bold fs-4">تحول مدیریت دانش با هوش مصنوعی</h5>
                        <p className="custom-p fw-light" style={{ lineHeight: '42px', fontSize: '20px' }}>
                            اما در حال حاضر خِردجو به کمک فناوری LLM توانسته این مشکلات را حل نموده و امکانات نوین و
                            کاربردی
                            را از مدیریت اسناد و اطلاعات سازمان ارائه نماید.
                        </p>
                    </div>
                </div>
            </section>

            <section className="container justify-content-center text-start" id="features">
                <h5 className="mt-5 mb-lg-4 mb-3 fw-bold fs-4">عملکرد خردجو</h5>
                <p className="custom-p fw-light" style={{ lineHeight: '42px', fontSize: '20px' }}>
                    در نمونه اول تعداد زيادى از آیين نامه‌ها در بخش HSE حوزه معدن به خردجو ارائه شده است،
                    در نمونه دوم نيز بخشى از دستورالعمل‌هاى تعمير و نگهـدارى آمده است همانطور كه مشاهده
                    می‌كنيد يک صفحه‌ از آنها به طور تصادفى نمونه‌بردارى شده و يک سوال پرسيده شده است
                    كه پاسخ را در زير مشاهده مى‌كنيد:
                </p>
                <div
                    className="col-lg-6 col-md-12 col-sm-12 d-flex justify-content-center align-items-center my-auto"
                    style={{ margin: "0 auto" }}>
                    <img
                        src={MiddleImg3}
                        alt="Middle Image"
                        className="rounded-5"
                        style={{ height: "auto", width: "900px" }}
                    />
                </div>
            </section>


            <section style={{ marginBlock: '150px' }}>
                <div className="row w-100 d-flex p-5"
                    style={{ backgroundColor: 'rgba(245, 242, 255, 1)' }}>
                    <div className="col-lg-3 col-md-6 col-sm-12 text-start">
                        <h5 className="mb-3 mb-lg-4 w-auto fw-bold fs-1">
                            ویژگی ها و امکانات <span style={{ color: 'rgba(110, 68, 255, 1)' }}>خرد</span><span
                                style={{ color: 'rgba(251, 156, 70, 1)' }}>جو</span>
                        </h5>
                        <p className="custom-p fw-light" style={{ lineHeight: '35px', fontSize: '20px' }}>
                            اما در حال حاضر خِردجو به کمک فناوری LLM توانسته این مشکلات را حل نموده و امکانات نوین و
                            کاربردی
                            را از مدیریت اسناد و اطلاعات سازمان ارائه نماید
                        </p>
                    </div>
                    <div className="col-lg-9 col-md-6 col-sm-12 d-flex flex-wrap justify-content-between px-lg-5">
                        <div className="faciliate text-end">
                            <img src={Faciliat1} alt="Facilitate 1" className="mx-0 my-0 faciliate-img" />
                            <p>ترجمه اسناد</p>
                        </div>
                        <div className="faciliate">
                            <img src={Faciliat2} alt="Facilitate 2" className="mx-0 my-0 faciliate-img" />
                            <p>مشابهت‌یابی اسناد</p>
                        </div>
                        <div className="faciliate">
                            <img src={Faciliat3} alt="Facilitate 3" className="mx-0 my-0 faciliate-img" />
                            <p>پشتیبانی از انواع داده</p>
                        </div>
                        <div className="faciliate">
                            <img src={Faciliat4} alt="Facilitate 4" className="mx-0 my-0 faciliate-img" />
                            <p>تولید دانش</p>
                        </div>
                        <div className="faciliate">
                            <img src={Faciliat5} alt="Facilitate 5" className="mx-0 my-0 faciliate-img" />
                            <p>مقایسه آیتم‌های دانشی</p>
                        </div>
                        <div className="faciliate">
                            <img src={Faciliat6} alt="Facilitate 6" className="mx-0 my-0 faciliate-img" />
                            <p>پردازش داده‌های انبوه</p>
                        </div>
                        <div className="faciliate">
                            <img src={Faciliat7} alt="Facilitate 7" className="mx-0 my-0 faciliate-img" />
                            <p>تحلیل و استنتاج</p>
                        </div>
                        <div className="faciliate">
                            <img src={Faciliat8} alt="Facilitate 8" className="mx-0 my-0 faciliate-img" />
                            <p>ارائه راهکار و پیشنهاد</p>
                        </div>
                        <div className="faciliate">
                            <img src={Faciliat9} alt="Facilitate 9" className="mx-0 my-0 faciliate-img" />
                            <p>خلاصه‌سازی دانش</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className="configs row container d-flex justify-content-center mx-auto">
                <div className="col-lg-6 col-md-12 col-sm-12 text-center my-auto w-auto">
                    <img
                        src={ConfigsImg}
                        alt="Middle Image"
                        className="mx-auto my-auto"
                        style={{ maxWidth: "230px", width: "100%", height: "auto" }}
                    />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 pb-5 mx-5" style={{ width: '450px' }}>
                    <div className="card border-0">
                        <div className="card-header bg-transparent border-0">
                            <h5 className="mt-5 mb-2 fw-bold fs-4">مشخصات فنی</h5>
                        </div>
                        <div className="card-body row row-gap-3 column-gap-2">
                            <div className="col-auto rounded-5 py-2 px-4"
                                style={{ backgroundColor: 'rgba(239, 234, 255, 1)' }}>
                                <p className="my-auto mx-auto fw-semibold py-2"
                                    style={{ color: 'rgba(110, 68, 255, 1)' }}>
                                    LLM
                                </p>
                            </div>
                            <div className="col-auto rounded-5 py-2 px-4"
                                style={{ backgroundColor: 'rgba(239, 234, 255, 1)' }}>
                                <p className="my-auto mx-auto fw-semibold py-2"
                                    style={{ color: 'rgba(110, 68, 255, 1)' }}>
                                    RAG
                                </p>
                            </div>
                            <div className="col-auto rounded-5 py-2 px-4"
                                style={{ backgroundColor: 'rgba(239, 234, 255, 1)' }}>
                                <p className="my-auto mx-auto fw-semibold py-2"
                                    style={{ color: 'rgba(110, 68, 255, 1)' }}>
                                    Instruction Finetuning
                                </p>
                            </div>
                            <div className="col-auto rounded-5 py-2 px-4"
                                style={{ backgroundColor: 'rgba(239, 234, 255, 1)' }}>
                                <p className="my-auto mx-auto fw-semibold py-2"
                                    style={{ color: 'rgba(110, 68, 255, 1)' }}>
                                    Ai Generative
                                </p>
                            </div>
                            <div className="col-auto rounded-5 py-2 px-4"
                                style={{ backgroundColor: 'rgba(239, 234, 255, 1)' }}>
                                <p className="my-auto mx-auto fw-semibold py-2"
                                    style={{ color: 'rgba(110, 68, 255, 1)' }}>
                                    Self Learning
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="models row w-100 d-flex p-5"
                style={{ backgroundColor: 'rgba(245, 242, 255, 1)' }}>
                <div className="d-flex flex-wrap justify-content-between gap-4">
                    <h5 className="w-auto fw-bold fs-3 my-auto fs-3">مدل‌های ارائه خدمات</h5>
                    <div className="d-flex gap-4">
                        <p className="fs-5 fw-bold my-auto">
                            As a Service
                        </p>
                        <img
                            src={Models1}
                            alt="Middle Image"
                            className="mx-auto my-auto"
                            style={{ maxWidth: "70px", height: "auto" }}
                        />
                    </div>
                    <div className="d-flex gap-4">
                        <p className="fs-5 fw-bold my-auto">
                            Cloud
                        </p>
                        <img
                            src={Models2}
                            alt="Middle Image"
                            className="mx-auto my-auto"
                            style={{ maxWidth: "70px", height: "auto" }}
                        />
                    </div>
                    <div className="d-flex gap-4">
                        <p className="fs-5 fw-bold my-auto">
                            On-Premise
                        </p>
                        <img
                            src={Models3}
                            alt="Middle Image"
                            className="mx-auto my-auto"
                            style={{ maxWidth: "70px", height: "auto" }}
                        />
                    </div>
                </div>
            </div>

            <section className="benefits" id="benefits">
                <h2 className="text-center">مزایای استفاده از خردجو در سازمان</h2>
                <div className="row benefits-container my-1">
                    <div className="col-lg-4 col-md-12 col-sm-12 mx-5 my-2 card benefits-card border-0">
                        <img src={Benefits1} alt="Benefit 1" />
                        <p className="fs-4 my-2 fw-bold">صرفه‌جویی در هزینه‌ها</p>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 mx-5 my-2 card benefits-card border-0">
                        <img src={Benefits2} alt="Benefit 2" />
                        <p className="fs-4 my-2 fw-bold">صرفه‌جویی در زمان</p>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 mx-5 my-2 card benefits-card border-0">
                        <img src={Benefits3} alt="Benefit 3" />
                        <p className="fs-4 my-2 fw-bold">دسترسی سریع به دانش</p>
                    </div>
                </div>
                <div className="row benefits-container my-1">
                    <div className="col-lg-4 col-md-12 col-sm-12 mx-5 my-2 card benefits-card border-0">
                        <img src={Benefits4} alt="Benefit 4" />
                        <p className="fs-4 my-2 fw-bold">افزایش بهره‌وری</p>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 mx-5 my-2 card benefits-card border-0">
                        <img src={Benefits5} alt="Benefit 5" />
                        <p className="fs-4 my-2 fw-bold">بهبود مدیریت دانش</p>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 mx-5 my-2 card benefits-card border-0">
                        <img src={Benefits6} alt="Benefit 6" />
                        <p className="fs-4 my-2 fw-bold">افزایش همکاری تیمی</p>
                    </div>
                </div>
            </section>

            <section className="about-us container px-0 mx-auto" id="about-us">
                <div className="d-lg-flex d-md-block d-sm-block justify-content-between">
                    <img
                        src={AboutImg}
                        alt="Middle Image"
                        className="mx-0 my-auto"
                        style={{ maxWidth: "400px", height: "auto", width: "auto" }}
                    />
                    <div className="about-us-text my-auto container w-auto">
                        <h3 className="fw-bold my-3">
                            درباره ما
                        </h3>
                        <p className="custom-p">
                            شرکت داده پردازان مبتکر آکام با نام تجاری دادماتک متشکل از اعضای هیئت علمی دانشگاه علم و
                            صنعت به عنوان شرکتی پیشرو در فناوری هوش مصنوعی شناخته می‌شود که موفق شده محصولات متعددی را
                            در حوزه‌های مختلف از جمله پردازش متن، پردازش صوت و پردازش تصویر تجاری‌سازی کند. این شرکت
                            دانش بنیان نوع یک با تکیه بر جوانان متخصص و نخبگان دانشگاهی، پروژه‌های تحقیق و توسعه را در
                            سطح ملی به بهره‌برداری رسانده و نقش‌آفرینی در توسعه اقتصاد دیجیتال کشور را جزو ماموریت‌های
                            اصلی خود می‌داند. در همین راستا، محصول خردجو با هدف ارزش‌آفرینی در مسیر توسعه هوشمندی
                            سازمان‌ها طراحی شده است تا تلاشی موفق را در جهت رشد و افزایش بهره‌وری سازمان‌های کشور شکل
                            دهد.
                        </p>
                    </div>
                </div>
            </section>

            <footer className="footer">
                <div
                    className="d-lg-flex d-md-block d-sm-block justify-content-between container border-bottom border-2 my-2">
                    <div className="footer-links">
                        <FiPhoneCall className="footer-icon" size={30} />
                        <p className="my-auto">9208232860 98+</p>
                    </div>
                    <div className="footer-links">
                        <FaMapMarkerAlt className="footer-icon" size={30} />
                        <p className="my-auto">
                            پارک علم و فناوری دانشگاه تهران، مرکز توسعه کسب و کار صنعت 4 واحد 303
                        </p>
                    </div>
                    <div className="footer-links">
                        <FaMapMarkerAlt className="footer-icon" size={30} />
                        <p className="my-auto">
                            دانشگاه علم و صنعت، دانشکده کامپیوتر، طبقه دوم
                        </p>
                    </div>
                    <div className="footer-links">
                        <FaEnvelope className="footer-icon" size={30} />
                        <p className="my-auto">
                            info@dadmatech.ir
                        </p>
                    </div>

                </div>
                <div className="footer-bottom" id="footer">
                    <div className="text-center mt-3 fs-6">
                        <p>تمام حقوق این سایت برای شرکت هوش مصنوعی <span><a href="https://dadmatech.ir/#/"
                            className="text-decoration-none text-white">دادماتک</a></span> محفوظ
                            است.</p>
                    </div>

                </div>
            </footer>
        </div>
    );
}

export default Landing;
